<template>
  <div class="menu">
    <div class="ys-menuBox" :style="!indexOne || {background: 'rgba(0, 0, 0, .3)'}">
      <div
        :class="[indexOne ? 'ys-menuIndex' : 'ys-menuNotIndex', !menuColor || 'productMenu', 'minMenu']"
        :style="indexOne ? menuStyle : {}"
      >
        <ul ref="ulHeight">
          <template v-for="(item, i) of menuList" v-if="!item.meta.menuHide">
            <li :key="i" @click="routerPush(item.children[0].name)"><span>{{item.meta.title}}</span></li>
          </template>
          <li><span><a href="https://www.pwstec.com/agent/#/" target="view_window">平台登陆</a></span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
// BY zgc19 ON 2019/1/17
    name: 'menus',
    props: {
      indexOne: {
        type: Boolean,
        default: true
      },
      openMenu: {
        type: Boolean,
        default: false
      },
      menuColor: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        menuList: this.$store.getters.muenList,
        menuHeight: '',
        menuStyle: {
          height: '1px',
          width: '1px',
          opacity: '0'
        }
      }
    },
    watch: {
      openMenu (to, form) {
        let odlObj = {
          height: '1px',
          width: '1px',
          opacity: '0'
        }
        let obj = {
          height: this.$store.state.app.windowHeight + 'px',
          width: (Number(this.ulStyle.width.split('p')[0]) + 40) + 'px',
          opacity: '1'
        }
        let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        obj.width = width <= 1000 ? obj.width = width + 'px' : obj.width
        this.menuStyle = to ? obj : odlObj
      }
    },
    created () {

    },
    methods: {
      routerPush (url, query) {
        this.$router.push({name: url, query})
      }
    },
    mounted () {
      this.ulStyle = window.getComputedStyle(this.$refs.ulHeight) // 获取ul高度
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  @function p2r($size) {
    @return $size/75 * 1rem;
  }

  @function p1r($size) {
    @return $size/192 * 1rem;
  }

  .menu {
    .ys-menuBox {

      // 如果是首页样式
      .ys-menuIndex {
        overflow: hidden;
        transition: height .3s, width .3s .5s, opacity .9s;
      }
    }
  }

  @media screen and (min-width: 750px) {
    .menu {
      .ys-menuBox {

        // 如果是首页样式
        .ys-menuIndex {
          overflow: hidden;
          transition: height .3s, width .3s .5s, opacity .9s;

          ul {
            padding: 80px 20px 20px;
            width: 300px;

            li {
              height: 52px;
              line-height: 52px;
              border-bottom: 1px solid #fff;
              cursor: pointer;

              span {
                transition: color .3s;
                font-size: 18px;
                color: #fff;

                a {
                  transition: color .3s;
                  font-size: 18px;
                  color: #fff;
                }
              }

              &:hover span {
                color: #42c3ee;
              }

              &:hover span a {
                color: #42c3ee;
                -webkit-tap-highlight-color: transparent;
              }
            }
          }
        }

        // 不是首页样式
        .ys-menuNotIndex {
          ul {
            display: flex;

            li {
              cursor: pointer;
              padding: 0 p1r(30);

              &:last-child {
                position: relative;

                &:before {
                  content: '';
                  display: block;
                  width: 2px;
                  height: 18px;
                  background: #ccc;
                  position: absolute;
                  top: 4px;
                  left: 0;
                }
              }

              span {
                font-size: 18px;
                color: #333;
                white-space: nowrap;

                a {
                  text-decoration: none;
                  font-size: 18px;
                  color: #333;
                  white-space: nowrap;
                }
              }

              &:hover span {
                transition: color .2s;
                color: #42c3ee;
              }

              &:hover span a {
                transition: color .2s;
                color: #42c3ee;
                -webkit-tap-highlight-color: transparent;
              }
            }
          }
        }

        // 如果是产品介绍
        .productMenu {
          ul li span {
            color: #fff;

            a {
              color: #fff;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 750px) {
    .menu {
      .ys-menuBox {
        .minMenu {
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, .8);

          ul {
            background: #42C3EE;
            padding-top: p2r(80);

            li {
              border-bottom: 1px solid #fff;
              padding: p2r(30);

              span, a {
                color: #fff;
                font-size: p2r(36);
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/menu.vue